// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Header-HeaderAction-module--cls1--hXurX","cls2":"Header-HeaderAction-module--cls2--gRe9k Header-HeaderAction-module--cls1--hXurX"};